// @flow

import React from 'react';
import PropTypes from "prop-types";
import T from './T';

const propTypes = {
    children: PropTypes.node.isRequired,
    width: PropTypes.string,
    className: PropTypes.string,
    value: PropTypes.string,
    /**
     * onClick(onClickParam, value);
     */
    onClick: PropTypes.func,
    onClickParam: PropTypes.any,
	type: PropTypes.string
};

const defaultProps = {
	className: 'btn btn-default btn-sm',
	type: "submit"
};


class Tbutton extends T {
	
	constructor(props) {
		super(props);
		this.onClick = this.onClick.bind(this);
	}
	
	onClick() {
		if (this.props.onClick) this.props.onClick(this.props.onClickParam, this.props.value);
	}
	
	render() {
		let buttonStyle = {};
		if (this.props.width) buttonStyle.width = this.props.width;
		let children = this.props.children;
		if (typeof(children) !== 'object') children = this.trans(children);
		return (<button type={this.props.type} className={this.props.className} value={this.props.value == null ? "" : this.props.value} onClick={this.onClick} style={buttonStyle}>{children}</button>);
	}
}

Tbutton.propTypes = propTypes;
Tbutton.defaultProps = defaultProps;

export default Tbutton;
